import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetIrrigationQuery,
  usePublicGetIrrigationQuery,
  useGetIrrigationSystemQuery,
  usePublicGetIrrigationSystemQuery,
  useGetIrrigationSystemDefaultsQuery,
  usePublicGetIrrigationSystemDefaultsQuery,
  useGetIrrigationPhaseQuery,
  usePublicGetIrrigationPhaseQuery,
  useGetIrrigationPhaseDefaultsQuery,
  usePublicGetIrrigationPhaseDefaultsQuery,
  useUpdateIrrigationsMutation,
  useUpdateIrrigationPhaseMutation,
  useCreateIrrigationPhaseMutation,
  useDeleteIrrigationPhaseMutation,
  useUpdateIrrigationSystemMutation,
  useCreateIrrigationSystemMutation,
  useDeleteIrrigationSystemMutation
} from '../features/modules/irrigationApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting irrigation data based on the current route.
 */
export const useContextAwareGetIrrigation = createContextAwareHook(
  useGetIrrigationQuery,
  usePublicGetIrrigationQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting irrigation system data based on the current route.
 */
export const useContextAwareGetIrrigationSystem = createContextAwareHook(
  useGetIrrigationSystemQuery,
  usePublicGetIrrigationSystemQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting irrigation system defaults based on the current route.
 */
export const useContextAwareGetIrrigationSystemDefaults = createContextAwareHook(
  useGetIrrigationSystemDefaultsQuery,
  usePublicGetIrrigationSystemDefaultsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting irrigation phase data based on the current route.
 */
export const useContextAwareGetIrrigationPhase = createContextAwareHook(
  useGetIrrigationPhaseQuery,
  usePublicGetIrrigationPhaseQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting irrigation phase defaults based on the current route.
 */
export const useContextAwareGetIrrigationPhaseDefaults = createContextAwareHook(
  useGetIrrigationPhaseDefaultsQuery,
  usePublicGetIrrigationPhaseDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateIrrigationsMutation,
  useUpdateIrrigationPhaseMutation,
  useCreateIrrigationPhaseMutation,
  useDeleteIrrigationPhaseMutation,
  useUpdateIrrigationSystemMutation,
  useCreateIrrigationSystemMutation,
  useDeleteIrrigationSystemMutation
}; 